import React from 'react';

function getScore({
  currentPage,
  isContactWithoutEmail,
  status,
  score,
  email,
  showFindEmail,
}) {
  return currentPage === 'advSearch'
    ? !showFindEmail
      ? '- N/A -'
      : status !== 'COMPLETE' && status !== 'INCOMPLETE' && !showFindEmail
      ? 'Inactive'
      : score === undefined || score === null || score <= 0
      ? '50%'
      : `${score}%`
    : email !== null && status === 'DEAD'
    ? 'Inactive'
    : isContactWithoutEmail
    ? '- N/A -'
    : score === undefined || score === null || score <= 0
    ? '50%'
    : `${score}%`;
}

const ContactEmailScore = props => {
  const {
    score,
    status = '',
    email = null,
    currentPage = 'advSearch',
    showFindEmail,
  } = props;

  const isContactWithoutEmail =
    status === 'ACTIVE_WITHOUT_EMAIL' ||
    status === 'ACTIVE_WITHOUT_EMAIL_PHONE';

  const deliverabilityScore = getScore({
    score,
    status,
    currentPage,
    isContactWithoutEmail,
    showFindEmail,
    email,
  });

  const classNameCondition =
    currentPage === 'advSearch' ? !showFindEmail : isContactWithoutEmail;

  return (
    <div
      className={`contact-email-score${classNameCondition ? ' no-email' : ''} ${
        deliverabilityScore.includes('75')
          ? ' 75'
          : deliverabilityScore.includes('85')
          ? ' 85'
          : deliverabilityScore.includes('95')
          ? ' 95'
          : deliverabilityScore.includes('50')
          ? ' 50'
          : ''
      }`}
    >
      {deliverabilityScore}
    </div>
  );
};

export { ContactEmailScore };
export default ContactEmailScore;
